import React, { useContext, useState } from "react";
import styles from "./Contact.module.scss";
import { Context } from "../Store";
import { contactSchema } from "./contactSchema";
import name0 from "./imgs/name0.png";
import name1 from "./imgs/name1.png";
import sms0 from "./imgs/sms0.png";
import sms1 from "./imgs/sms1.png";
import mobile0 from "./imgs/mobile0.png";
import mobile1 from "./imgs/mobile1.png";
import message0 from "./imgs/message0.png";
import message1 from "./imgs/message1.png";
import axios from "axios";
import { useFormik } from "formik";
import { toast } from "react-toastify";

const ContactForm = () => {
  let { baseURL, dir, translate, clickBtn, clickbtns, lang } =
    useContext(Context);
  let {
    name,
    namePlaceholder,
    email,
    emailPlaceholder,
    phone,
    phonePlaceholder,
    message,
    messagePlaceholder,
    btn,
  } = translate.contactUs;
  let [loading, setLoading] = useState(false);
  const [focus, setFocus] = useState("");
  const onSubmit = async (values, actions) => {
    setLoading(true);
    try {
      let { data } = await axios.post(`${baseURL}/website/support`, values, {
        headers: {
          Accept: "application/json",
          lang: lang,
        },
      });
      setLoading(false);
      if (data.status === 1 && data.message === "success") {
        toast.success(data.message);
        // call safeUserData from App.jsx
        await new Promise((resolve) => setTimeout(resolve, 2000));
        actions.resetForm();
      }
    } catch (error) {
      toast.error(
        error?.message ||
          error?.response?.date?.message ||
          "Something went wrong",
        {
          position: "top-right",
        }
      );
    }
  };
  const { values, errors, touched, isSubmitting, handleChange, handleSubmit } =
    useFormik({
      initialValues: {
        email: "",
        name: "",
        phone: "",
        message: "",
      },
      validationSchema: contactSchema,
      onSubmit,
    });
  return (
    <>
      <form id={styles.inputs} onSubmit={handleSubmit}>
        <div className={styles.input}>
          <label
            htmlFor="name"
            className={focus === "name" ? styles.active : ""}
          >
            <img
              src={focus === "name" ? name1 : name0}
              style={dir === "ltr" ? { marginRight: 8 } : { marginLeft: 8 }}
              alt=""
            />
            {dir === "ltr" ? name[0] : name[1]}
          </label>
          <input
            value={values.name}
            onChange={handleChange}
            type="text"
            onFocus={() => setFocus("name")}
            onBlur={() => setFocus("")}
            id="name"
            name="name"
            placeholder={
              dir === "ltr" ? namePlaceholder[0] : namePlaceholder[1]
            }
            className={`${errors.name && touched.name ? "inputError" : ""}`}
          />
          {errors.name && touched.name && (
            <p className="error">{errors.name}</p>
          )}
        </div>
        <div className={styles.input}>
          <label
            htmlFor="email"
            className={focus === "email" ? styles.active : ""}
          >
            <img
              src={focus === "email" ? sms1 : sms0}
              style={dir === "ltr" ? { marginRight: 8 } : { marginLeft: 8 }}
              alt=""
            />
            {dir === "ltr" ? email[0] : email[1]}
          </label>
          <input
            value={values.email}
            onChange={handleChange}
            type="email"
            onFocus={() => setFocus("email")}
            onBlur={() => setFocus("")}
            id="email"
            name="email"
            placeholder={
              dir === "ltr" ? emailPlaceholder[0] : emailPlaceholder[1]
            }
            className={`${errors.email && touched.email ? "inputError" : ""}`}
          />
          {errors.email && touched.email && (
            <p className="error">{errors.email}</p>
          )}
        </div>
        <div className={styles.input}>
          <label
            htmlFor="phone"
            className={focus === "phone" ? styles.active : ""}
          >
            <img
              src={focus === "phone" ? mobile1 : mobile0}
              style={dir === "ltr" ? { marginRight: 8 } : { marginLeft: 8 }}
              alt=""
            />
            {dir === "ltr" ? phone[0] : phone[1]}
          </label>
          <input
            value={values.phone}
            onChange={handleChange}
            type="number"
            onFocus={() => setFocus("phone")}
            onBlur={() => setFocus("")}
            id="phone"
            name="phone"
            placeholder={
              dir === "ltr" ? phonePlaceholder[0] : phonePlaceholder[1]
            }
            className={`${errors.phone && touched.phone ? "inputError" : ""}`}
          />
          {errors.phone && touched.phone && (
            <p className="error">{errors.phone}</p>
          )}
        </div>
        <div className={styles.input}>
          <label
            htmlFor="message"
            className={focus === "message" ? styles.active : ""}
          >
            <img
              src={focus === "message" ? message1 : message0}
              style={dir === "ltr" ? { marginRight: 8 } : { marginLeft: 8 }}
              alt=""
            />
            {dir === "ltr" ? message[0] : message[1]}
          </label>
          <textarea
            value={values.message}
            onChange={handleChange}
            type="text"
            onFocus={() => setFocus("message")}
            onBlur={() => setFocus("")}
            id="message"
            name="message"
            cols=""
            rows=""
            placeholder={
              dir === "ltr" ? messagePlaceholder[0] : messagePlaceholder[1]
            }
            className={`${
              errors.message && touched.message ? "inputError" : ""
            }`}
          ></textarea>
          {errors.message && touched.message && (
            <p className="error">{errors.message}</p>
          )}
        </div>
        <button
          onClick={() => clickBtn("contactUsForm", 70)}
          className={clickbtns === "contactUsForm" ? "clickBtns" : ""}
          disabled={isSubmitting || loading}
          type="submit"
        >
          {loading ? (
            <i className="fas fa-spinner fa-spin"></i>
          ) : (
            ` ${dir === "ltr" ? btn[0] : btn[1]}`
          )}
        </button>
      </form>
    </>
  );
};

export default ContactForm;
